export default __webpack_public_path__ + "static/media/autoCar.16b15763.png";